import { jsxs as t, jsx as r, Fragment as m } from "react/jsx-runtime";
import i from "../../../../node_modules/prop-types/index.es.js";
import * as h from "./style.es.js";
import { Header as u, HeaderTitle as p, CloseButton as y } from "./style.es.js";
import { VerticalDivider as g } from "../../../DataDisplay/Dividers/Dividers.es.js";
import { StepBar as v } from "../../../DataDisplay/StepBar/StepBar.es.js";
import { Button as k } from "../../../Inputs/Button/Button.es.js";
import { Icon as n } from "../../../DataDisplay/Icon/Icon.es.js";
import { Typography as C } from "../../../Typography/Typography.es.js";
const o = ({
  activeStepIndex: c,
  components: e,
  onBack: f,
  onRequestClose: l,
  title: d,
  steps: a = []
}) => /* @__PURE__ */ t(u, { hasStepBar: !!(a != null && a.length), children: [
  /* @__PURE__ */ t(p, { children: [
    f && /* @__PURE__ */ r(m, { children: /* @__PURE__ */ t(k, { variant: "link", onClick: f, children: [
      /* @__PURE__ */ r(n, { name: "left-chevron", size: "lg", color: "black" }),
      /* @__PURE__ */ r(g, {})
    ] }) }),
    d && /* @__PURE__ */ r(C, { variant: "h4", children: d })
  ] }),
  /* @__PURE__ */ r(v, { steps: a, activeStepIndex: c, direction: "horizontal", labelPosition: "end" }),
  (e == null ? void 0 : e.LeftOfClose) && /* @__PURE__ */ r(e.LeftOfClose, {}),
  /* @__PURE__ */ r(y, { variant: "link", onClick: () => l == null ? void 0 : l(!1), style: {
    marginLeft: e != null && e.LeftOfClose ? "unset" : "auto"
  }, children: /* @__PURE__ */ r(n, { name: "close", size: "lg", color: "var(--color-neutral-800)" }) })
] });
o.S = h;
o.displayName = "Modal.Header";
o.propTypes = {
  activeStepIndex: i.number,
  components: i.shape({
    LeftOfClose: i.func,
    SecondaryContent: i.func
  }),
  onBack: i.func,
  onRequestClose: i.func.isRequired,
  title: i.string
};
export {
  o as Header
};
//# sourceMappingURL=Header.es.js.map
